import React from 'react';
import { Route } from 'react-router-dom';
import UebersichtPage from 'modules/finanzen/pages/UebersichtPage';
import FinanzenPage from 'modules/finanzen/pages/FinanzenPage';
import OrtDetailPage from 'modules/finanzen/pages/OrtDetailPage';
import JahresuebersichtPage from 'modules/finanzen/pages/JahresuebersichtPage';
import DauerauftraegePage from 'modules/finanzen/pages/DauerauftraegePage';
import finanzenReducer from 'modules/finanzen/features/finanzenSlice';
import investitionenReducer from 'modules/investitionen/features/investitionenSlice';

/**
 * Modul-Definition "Finanzen" (finanzen).
 *
 * Vereint Ausgaben-/Einnahmen-Tracking und die Investitionsuebersicht: pro
 * Investitionsort (z. B. Trade Republic) das Barvermoegen (Anfangsbestand +
 * zugeordnete Buchungen) und die Investitionen (Positionen). Alle Inhalte sind
 * Ende-zu-Ende verschluesselt und nur im "gesicherten Modus" erreichbar.
 *
 * Registriert beide State-Bereiche (finanzen + investitionen); die
 * investitionen-Features/-Komponenten dienen als gemeinsam genutzte Bibliothek.
 */
const finanzenModul = {
  id: 'finanzen',
  name: 'Finanzen',
  description:
    'Verschlüsseltes Vermögens-Tracking – Barvermögen und Investitionen je Ort, schnelles Erfassen, Monat und Jahr im Blick. Nur im gesicherten Modus sichtbar.',
  path: '/projekte/finanzen',
  icon: '📊',
  gradient: 'from-emerald-400 to-teal-600',
  status: 'active',
  // Nur im gesicherten Modus (entsperrter Tresor) erreichbar/sichtbar.
  secured: true,
  reducers: {
    finanzen: finanzenReducer,
    investitionen: investitionenReducer,
  },
  routes: (
    <>
      <Route path="/projekte/finanzen" element={<UebersichtPage />} />
      <Route path="/projekte/finanzen/monat" element={<FinanzenPage />} />
      <Route path="/projekte/finanzen/dauerauftraege" element={<DauerauftraegePage />} />
      <Route path="/projekte/finanzen/jahr" element={<JahresuebersichtPage />} />
      <Route path="/projekte/finanzen/ort/:uuid" element={<OrtDetailPage />} />
    </>
  ),
};

export default finanzenModul;
